import type { BrandConfig } from '@@fire-b2b/types/Brand'
import type { GQLResult } from '@fire-b2b/utils/gql'

export async function fetchBrandsConfigs(): Promise<GQLResult<BrandConfig[]>> {
  const auth = useAuth()

  let response: Response
  try {
    response = await fetch(`/api/brands-configs`)
  } catch {
    return err({
      statusCode: 500,
      message: 'Failed to fetch brands from API.',
    })
  }

  if (!response.ok) {
    if (response.status === 401) {
      await auth.logout()
    }

    return err({
      statusCode: response.status,
      message: `${response.status}: ${response.statusText}`,
    })
  }

  const brandsConfigs: BrandConfig[] = await response.json()

  return ok(brandsConfigs)
}
